import React, { useState } from "react";
import { ReactComponent as Tick } from "../../assets/icons/tick.svg";
export const CheckBox = () => {
  const [checked, setChecked] = useState(true);
  return (
    <div className="Reminder" onClick={() => setChecked(!checked)}>
      <span>صدور قبض های بعدی را به من یادآوری کن.</span>
      <div>{checked && <Tick />}</div>
    </div>
  );
};
export const CheckBoxLogin = ({ checked, setChecked }) => {
  return (
    <div
      id="Billhistory"
      className="Reminder ReminderWhite"
      onClick={() => setChecked(!checked)}
    >
      <span>قوانین و مقررات را مشاهده کردم و میپذیرم</span>
      <div>{checked && <Tick />}</div>
    </div>
  );
};
